import React,{useState} from 'react';

import "./css/boxshadow.css";
const Boxshadow = () => {
    const [horizontal, setHorizontal] = useState(10);
    const [vertical, setVertical] = useState(10);
    const [blur, setBlur] = useState(30);
    const [color, setColor] = useState("#7862b7");
    const [checkInset, setCheckInset] = useState(false);
    function copy(){
        const inset=(checkInset)?"inset ":" ";
        // console.log(inset)
        var value="box-shadow: "+inset +horizontal+"px "+vertical+"px "+blur+"px "+color;
        // console.log(value)
        navigator.clipboard.writeText(value);
    }
    console.log();
    return (
        <div className="boxshadow-body">
            <div className="boxshadow-controls">
                <label htmlFor="horizontal-bar">Horizontal Length</label>
                <input className="boxshadow-slider" id="horizontal-bar" type="range" min="-200" max="200" value={horizontal} onChange={(e)=>setHorizontal(e.target.value)}/>
               
                <label htmlFor="vertical-bar">Vertical Length</label>
                <input className="boxshadow-slider" id="vertical-bar" type="range" min="-200" max="200" value={vertical} onChange={(e)=>setVertical(e.target.value)}/>
               
                <label htmlFor="blur-bar">Blur Length</label>
                <input className="boxshadow-slider" id="blur-bar" type="range" min="0" max="200" value={blur} onChange={(e)=>setBlur(e.target.value)}/>
               
                <label htmlFor="color-bar">Pick Color</label>               
                <input id="color-bar" type="color" value={color} onChange={(e)=>setColor(e.target.value)}/>
                
                <span>Outline</span>
                <input className="switch_1" type="checkbox" checked={checkInset} onChange={()=>setCheckInset(!checkInset)}/>
                <span htmlFor="">Inset</span>    
                    
                
            </div>
            <div className="boxshadow-output">
                <div className="boxshadow-box" style={{boxShadow:`${checkInset?"inset":""} ${horizontal}px ${vertical}px ${blur}px ${color}`}}>
                    <p>box-shadow: {checkInset?"inset":""} {horizontal}px {vertical}px {blur}px {color}</p>
                    <br />
                    <button onClick={() => copy()} >
                        Copy
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Boxshadow
